import { Route, Switch, useRouteMatch } from 'react-router-dom'

import RenewalSampleEmail from 'adminDashboard/home/groupHra/notifyEmployeesTask/RenewalSampleEmail'

import { ROUTE_PATHS } from 'common/routePaths'

import NotFound from 'errorPages/NotFound'

import CompleteProfileAdminProfile from './common/completeAdminProfile'
import EditEmployeeForm from './common/editEmployeeForm'
import EditEmployeePersonalDetailsForm from './common/editEmployeePersonalDetailsForm'
import EmployeeDetails from './common/employeeDetails'
import ImportUsers from './common/importUsers'
import EmployeeSampleEmail from './groupHra/invitation/EmployeeSampleEmail'
import ViewPeople from './viewPeople'

export const MANAGE_PEOPLE_PATH = '/manage-people'
export const EMPLOYEE_SAMPLE_EMAIL_PATH = '/sample-email'
export const RENEWAL_SAMPLE_EMAIL_PATH = '/sample-renewal-email'

const Routes = () => {
  const match = useRouteMatch()

  return (
    <Switch>
      <Route path={`${match.path}`} exact component={ViewPeople} />
      <Route path={`${match.path}${EMPLOYEE_SAMPLE_EMAIL_PATH}`} exact component={EmployeeSampleEmail} />
      <Route path={`${match.path}${RENEWAL_SAMPLE_EMAIL_PATH}`} exact component={RenewalSampleEmail} />
      <Route path={`${match.path}/complete-admin-profile`} exact component={CompleteProfileAdminProfile} />
      <Route path={`${match.path}/edit/:companyUserId?`} exact component={EditEmployeeForm} />
      <Route
        path={`${match.path}/edit-personal-details/:companyUserId?`}
        exact
        component={EditEmployeePersonalDetailsForm}
      />
      <Route path={`${match.path}/view/:id`} exact component={EmployeeDetails} />
      <Route path={`${match.path}/${ROUTE_PATHS.IMPORT_USERS}`} exact component={ImportUsers} />
      <Route component={NotFound} />
    </Switch>
  )
}

export default Routes
